"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appInitialRecipeFormValues = exports.initialRecipeFormValues = void 0;
const common_1 = require("@saffron/common");
const commonInitial = {
    name: "",
    description: null,
    croppedBase64Img: null,
    times: [],
    ingredients: [],
    cookbookId: null,
    sectionId: null,
    servings: null,
    source: null,
    sourceUrl: null,
};
exports.initialRecipeFormValues = Object.assign(Object.assign({}, commonInitial), { instructions: common_1.emptyValueJSON });
exports.appInitialRecipeFormValues = Object.assign(Object.assign({}, commonInitial), { instructions: common_1.emptyValueJSON });
//# sourceMappingURL=recipeInitialValues.js.map